import { useEffect } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { setSessionCookie } from "@/server/auth";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallback,
});

function AuthCallback() {
  const navigate = useNavigate();
  const searchParams = useSearch({ strict: false }) as {
    token?: string;
    returnToUrl?: string;
    message?: string;
  };

  useEffect(() => {
    const handleCallback = async () => {
      const { token, returnToUrl } = searchParams;
      const destination = returnToUrl || "/";

      try {
        if (token) {
          console.log("✅ OAuth callback received, setting session cookie");
          await setSessionCookie({ data: { token } });
        }

        console.log("✅ Redirecting to:", destination);
        window.location.assign(destination);
      } catch (error) {
        console.error("❌ Error handling OAuth callback:", error);
        navigate({ to: "/" });
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="mb-4 text-lg">Completing sign in...</div>
        <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
      </div>
    </div>
  );
}
